import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

import * as classNames from 'classnames';
import fonts from 'src/constants/fonts';
import stylesheet, { directions } from 'src/constants/stylesheet';
import FadeInUp from 'src/utils/FadeInUp';

export type PanelTextProps =
    React.HTMLAttributes<HTMLElement> &
    {
        dto: PanelTextDto,
        secondaryPage?:  boolean
    };

const styles = {
    container: {
        ...stylesheet.TextBlocks,
        ...stylesheet.Text,
        ...stylesheet.PaddingGutter(1, directions.sides | directions.top),

        '& a': {
            borderBottom: '1px solid black',
            ...stylesheet.Link(false, 'center'),

            '&:hover': {
                borderColor: 'transparent'
            },
        },
        '& strong': {
            ...fonts.Granjon.Bold,
        },
    },
    secondaryPageText: {
        maxWidth: 820
    },
};

type Props =
    PanelTextProps &
    StyledComponentProps<keyof typeof styles>;

const PanelText: React.FunctionComponent<Props> = (props) => {
    const {
        children,
        classes,
        secondaryPage,
        dto: { Text },
        ...rest
    } = props;
    return (
        <div
            {...
                { 
                    ...rest, 
                    className: classNames(
                                    rest.className, classes!.container, secondaryPage && classes!.secondaryPageText) }
            }
        >
            <FadeInUp>
                <div dangerouslySetInnerHTML={{ __html: Text }} />
            </FadeInUp>
        </div>
    );
}

export default withStyles(styles)(PanelText);


// WEBPACK FOOTER //
// ./src/components/Panels/PanelText.tsx